import { FC } from 'react'
import Badge from '@/components/atoms/badge'
import Link from '@/components/atoms/link'
import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { Tiny2 } from '../atoms/typography'

type MobileHeaderButtonRedesignProps = {
  hrefLink: string
  notifyCount?: number
  IconElement: JSX.Element
  title: string
  isCartButton?: boolean
} & Rest

const MobileHeaderButtonRedesign: FC<MobileHeaderButtonRedesignProps> = ({
  hrefLink,
  notifyCount,
  IconElement,
  title,
  isCartButton,
  ...rest
}) => {
  return (
    <Link href={hrefLink}>
      <StyledFlex {...rest}>
        {IconElement}
        <StyledTitle>{title}</StyledTitle>
        {notifyCount >= 0 && isCartButton ? (
          <StyledBadge counter={notifyCount} />
        ) : notifyCount ? (
          <StyledBadge counter={notifyCount} />
        ) : null}
      </StyledFlex>
    </Link>
  )
}
export default MobileHeaderButtonRedesign

const StyledFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  gap: 3px;
  padding: 10px 0px 5px;
  &:hover {
    cursor: pointer;
  }
`

const StyledTitle = styled(Tiny2)`
  padding: 0;
  margin: 0;
  opacity: 0.6;
  font-size: 11px;
  line-height: 1.27; ;
`

const StyledBadge = styled(Badge)`
  position: absolute;
  left: 60%;
  top: 6px;
`
